module.exports = __webpack_public_path__ + "img/izi.ab505be3.png";